import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    collapsed: false,
    page: '',
    alert: null
}

export const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.collapsed = !state.collapsed
        },
        setPage: (state, action) => {
            state.page += action.payload
        },
        setAlert: (state, action) => {
            state.alert = action.payload;
        }
    },
})

// Action creators are generated for each case reducer function
export const { toggleSidebar, setPage, setAlert } = layoutSlice.actions

export default layoutSlice.reducer